import type { Person, TripView } from "./api.ts";
import { FORMER_MEMBER } from "./faces.ts";
import { Icon } from "./souvenir.ts";

// Former members (features/privacy-and-data.md): people whose account was deleted. What they added stays,
// from "a former member": no name, no photo, a face of its own. Tripmo names them so in sentences; where
// the name starts a line it's "A former member".

// A person's name where it starts a line or a label.
export function asLabel(name: string): string {
  return name === FORMER_MEMBER ? "A former member" : name;
}

export const isFormer = (p: { name: string; former?: true } | undefined) =>
  p?.former === true || p?.name === FORMER_MEMBER;

// Everyone who can be named in the trip: its members, then its former members.
export function everyone(trip: Pick<TripView, "members" | "former">): Person[] {
  return [...trip.members, ...(trip.former ?? [])];
}

// The ids of those in the trip now: whose a to-do is (src/waits.ts, `ownerNow`). One whose owner has left
// (removed, gone, or a former member) is nobody's.
export function membersNow(trip: Pick<TripView, "members">): ReadonlySet<string> {
  return new Set(trip.members.map((m) => m.id));
}

// A former member's face: no initials, no photo, the same size and shape as a person's.
export function FormerFace({ size = 36, className }: { size?: number; className?: string }) {
  return (
    <span
      className={`sv-avatar tm-former-face${className ? ` ${className}` : ""}`}
      style={{ width: size, height: size }}
      role="img"
      aria-label="A former member"
      title="A former member"
    >
      <Icon name="people" size={Math.max(14, Math.round(size * 0.46))} />
    </span>
  );
}
